export default "__VITE_ASSET__135b0c2b__"